import Vue from 'vue';
import skySearch from './sky-search';

// Main component
Vue.component('sky-search', skySearch);

export default skySearch;



// WEBPACK FOOTER //
// ./scripts/sky-search/index.js